import { render, staticRenderFns } from "./NotificationLabel.vue?vue&type=template&id=f784a9bc"
import script from "./NotificationLabel.vue?vue&type=script&lang=js"
export * from "./NotificationLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports